"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultChannelEvents = void 0;
exports.DefaultChannelEvents = [
    "initialized",
    "subscribing",
    "subscribed",
    "unsubscribing",
    "unsubscribed",
    "suspended",
    "failed",
    "update",
];
